import styled from "styled-components";
import { SIDEBAR_W, TOPBAR_H } from "../../config/layout";

/* Franja blanca común a todas las pantallas, con el logo arriba a la izquierda.
   Es fija, así que cada vista deja ${TOPBAR_H} de hueco arriba. */
export const Bar = styled.header`
  position: fixed;
  top: 0; left: 0; right: 0;
  height: ${TOPBAR_H};
  background: #fff;
  display: flex;
  align-items: center;
  z-index: 200;
`;

/* El logo ocupa el ancho de la barra lateral: así queda alineado con ella */
export const Logo = styled.div`
  width: ${SIDEBAR_W};
  min-width: ${SIDEBAR_W};
  padding: 0 24px;
  box-sizing: border-box;
  display: flex;
  align-items: center;

  img { width: 92px; }
`;

export const BarContent = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 16px;
  padding-right: 24px;
`;
